/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { TableCell, TableRow } from "@mui/material";
import { Link, NavLink } from "react-router-dom";
import clsx from "clsx";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image, Space, Dropdown, Menu } from "antd";
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import moment from 'moment';
import { purchaseSelfBillHead } from "../../../../../config/constant";
import { capitalizeFirstLetter, currencyFormat, checkCRUDPermission, checkComponentPermission, getColumnWidth, downloadTitle, idNamingConversion } from "../../../../../helpers/utilities";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import PurchaseInvoiceModal from "../../../../Shared/components/PurchaseInvoiceModal";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { AESEncrypt } from "../../../../../helpers/Crypto";
import SearchText from '../../../../Shared/components/SearchText';


export const SelfBillTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, search, loadTasks, businessDetails, productGstdetails, loadMore, loadMoreContent, loadMoreTask, roleManagement } = props;
    const { editDetails, editError } = useSelector(state => state.crudReducer);
    const [billId, setBillId] = useState('');
    const [billDeleteId, setBillDeleteId] = useState('');
    //   const [name, setName] = useState('');
    const [open, setOpen] = useState(false);
    const [copy, setCopy] = useState(false);
    const dispatch = useDispatch();
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const classes = customStyles();
    const [readDetails, setReadDetails] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);


    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setBillId(data?.serialNo);
        setBillDeleteId(data?.id);
        // setName(data.name);
    }

    const handleClose = (o) => (
        setOpen(o)
    );


    const handleStatus = (id, status) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'purchaseSelfBill',
            title: 'Purchase Self Bill',
            id: id,
            details: {
                billStatus: status
            }
        });
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            //toast(editDetails);
            loadTasks();
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError.error.message;
            toast.dismiss();
            toast.error(message);
        }
    }, [editDetails, editError]);

    const handleShareDocument = (data, copy) => {
        setOpen(true);
        setCopy(copy);
        setReadDetails(data);
        setBillId(data.id);
    }



    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={purchaseSelfBillHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                width={true}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={purchaseSelfBillHead.length}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}  >
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'view', 'Purchase') ?
                                                            <Link id={idNamingConversion('View_' + data.id, 'purchaseBill', 'Link')} style={{ width: getColumnWidth(purchaseSelfBillHead, 0) }} to={`/purchase/purchase-management/self-bill/${AESEncrypt(data.id)}/view`} className={clsx(classes.color, classes.bold)}>
                                                                {data.serialNo ? data.serialNo : '---'}</Link> : <span style={{ width: getColumnWidth(purchaseSelfBillHead, 0) }}>{data?.serialNo}</span>
                                                    }
                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 1) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 1) }}>{data?.name}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 2) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 2) }}>{`${data?.supplier?.serialNo ? data?.supplier?.serialNo : '---'}`}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 3) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 3) }}>{data.phone}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 4) }} className={classes.rightAlignAmount}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 4) }}>{'₹  '}{currencyFormat(data.invoiceAmount)}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 5) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 5) }}>{moment(data?.invoiceDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 6) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 6) }}>{moment(data?.dueDate).format('DD MMM YYYY')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 7) }}><span style={{ width: getColumnWidth(purchaseSelfBillHead, 7) }}>{moment(data?.createTs).format('DD MMM YYYY hh:mm A')}</span></TableCell>
                                                <TableCell style={{ width: getColumnWidth(purchaseSelfBillHead, 8) }}><div className={clsx(classes.statusButton, { [classes.confirmedButton]: data.billStatus === 'CONFIRMED' }, { [classes.reversedButton]: data.billStatus === 'REVERSED' }, { [classes.cancelledButton]: data.billStatus === 'CANCELLED' })}>{capitalizeFirstLetter(data.billStatus)}</div></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding, classes.actionWidth)}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'view', 'Purchase') &&
                                                            <Link id={idNamingConversion('View_' + data.id, 'purchaseBill', 'Icon')} to={`/purchase/purchase-management/self-bill/${AESEncrypt(data.id)}/view`}>
                                                                <Image src={ViewIcon} preview={false} />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'edit', 'Purchase') &&
                                                            <Link id={idNamingConversion('Edit_' + data.id, 'purchaseBill', 'Icon')} className={clsx({ [classes.disabled]: data.billStatus !== 'CREATED' || data?.supplier?.isHold })} to={`/purchase/purchase-management/self-bill/${AESEncrypt(data.id)}/edit`}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </Link>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supply Self Bill', 'deletable', 'Purchase') &&
                                                            <NavLink id={idNamingConversion('Delete_' + data.id, 'purchaseBill', 'Icon')} to={"#"} className={clsx({ [classes.disabled]: data.billStatus === 'CONFIRMED' || data.billStatus === 'REVERSED' || data.billStatus === 'CANCELLED' })} onClick={() => onDelete(data)}>
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    {
                                                                        (data.billStatus === 'CONFIRMED' || data.billStatus === 'REVERSED' || data.billStatus === 'CANCELLED') ?
                                                                            <React.Fragment>
                                                                                <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                                {
                                                                                    roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Ellipsis Action', 'Share Document') &&
                                                                                    <><Menu.Item key={"View Document"}><NavLink to={'#'} id={idNamingConversion('View Document_' + data.id, 'purchaseBill', 'Icon')} onClick={() => handleShareDocument(data, false)}>{data?.isViaNotification ? 'View Original' : 'View Original'}</NavLink></Menu.Item>
                                                                                        <Menu.Item key={"View Copy"}><NavLink to={'#'} id={idNamingConversion('View Copy_' + data.id, 'purchaseBill', 'Icon')} onClick={() => handleShareDocument(data, true)}>{data?.isViaNotification ? 'View Copy' : 'View Copy'}</NavLink></Menu.Item></>
                                                                                }
                                                                            </React.Fragment> : <React.Fragment>
                                                                                {
                                                                                    !data?.supplier?.isHold &&
                                                                                    <>
                                                                                        {
                                                                                            roleManagement !== '' && checkComponentPermission('Supply Self Bill', 'Ellipsis Action', 'Confirm') && data.selfBillItems !== undefined &&
                                                                                            <><Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                                                <Menu.Item key={"Confirmed"}><NavLink id={idNamingConversion('Confirmed_' + data.id, 'purchaseBill', 'Icon')} to={'#'} className={clsx({ [classes.disabled]: data.selfBillItems === undefined })} onClick={() => handleStatus(data.id, 'CONFIRMED')}>Confirm</NavLink></Menu.Item>
                                                                                            </>
                                                                                        }
                                                                                    </>
                                                                                }
                                                                            </React.Fragment>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'purchaseBill', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={purchaseSelfBillHead.length}>
                                                    {
                                                        search !== '' ? <SearchText /> : <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'All Supply Self  Bill and Debit Notes will be listed here when transactions are recorded by the system'}</p>
                                                    }
                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }

                    </>
                }
            />
            {
                open && (
                    <>
                        <PurchaseInvoiceModal open={open} copy={copy}
                            title={downloadTitle(readDetails, 'supply-bill')}
                            handleClose={(o) => handleClose(o)} link={''} {...props}
                            format={readDetails?.billFormat}
                            businessDetails={businessDetails} details={readDetails} productGst={productGstdetails} />
                    </>
                )
            }
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={billDeleteId} loadTasks={() => loadTasks()}
                name={billId} url={'purchaseSelfBill'} title={'Supply Self Bill'} visible={deleteModal} />
        </>
    )
}